import React from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { FormValues, validation } from './PlanForm.meta';
import { Textarea } from '../../../CommonComponents/OPL/Textarea/Textarea';
import { Input } from '../../../CommonComponents/OPL/Input/Input';

interface Props {
  formId: string;
  onSubmit(values: FormValues): void;
  defaultName?: string;
  defaultDescription?: string | null;
  isDisabled?: boolean;
}

export const PlanForm: React.FC<Props> = ({
  formId,
  onSubmit,
  defaultName = '',
  defaultDescription = '',
  isDisabled = false,
}) => {
  const {
    register,
    formState: { errors },
    handleSubmit,
  } = useForm<FormValues>({
    defaultValues: {
      name: defaultName,
      description: defaultDescription,
    },
    resolver: yupResolver(validation),
  });

  return (
    <form id={formId} onSubmit={handleSubmit(onSubmit)}>
      <Input
        {...register('name')}
        label="Plan Name"
        type="text"
        formVariant={errors.name ? 'error' : undefined}
        helperText={errors.name?.message || 'Max. 40 characters'}
        disabled={isDisabled}
        mb={10}
        maxLength={40}
      />

      <Textarea
        {...register('description')}
        label="Description"
        helperText="Max. 120 characters"
        maxLength={120}
        rows={4}
      />
    </form>
  );
};
